import React, { useState, useEffect } from 'react';
import { Title, usePermissions } from 'react-admin';

import AuditarRecetas from '../modules/validar-recetas/AuditarRecetas'

import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

import { sgxFetchApiWithToken } from '../libs/sgx/api/fetch';

import RulesReportCard from './reports/RulesReportCard';
import { CantidadPorEstadoCard, ReglasPorEstadoCard } from './dashboard/';
import {ADMINISTRADOR, AUDITOR, AUDITOR_RECETAS, LECTOR_RECETAS, ROOT} from "../modules/roles";

const Dashboard = () => {
    const [cubeError, setCubeError] = useState(null);
    const [loading, setLoading] = useState(true);
    const { permissions } = usePermissions();
    useEffect(() => {
        sgxFetchApiWithToken('dashboards/cubejs-api/v1/meta')
            .then(() => setCubeError(null))
            .catch(error => setCubeError(error))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (<LinearProgress />);
    }

    return (
        <div>
            {permissions.hasAnyAssignment(ROOT, ADMINISTRADOR, AUDITOR) &&
            <div>
                <Title title="ra.page.dashboard" />
                <Grid container spacing={3}>
                    <Grid item sm={8}>
                        <CantidadPorEstadoCard error={cubeError} />
                    </Grid>
                    <Grid item sm={4}>
                        <Grid container spacing={3} direction="row" alignItems="center">
                            <Grid item sm={12} >
                                <ReglasPorEstadoCard error={cubeError} />
                            </Grid>
                            <Grid item sm={12} >
                                <RulesReportCard error={cubeError} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            }
            <div>
                {permissions.hasAnyAssignment(AUDITOR_RECETAS, LECTOR_RECETAS) && <AuditarRecetas />}
            </div>
        </div>
    )
};

export default Dashboard;